import './footer.less'

import {Image, m} from '@codeurs/front'
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  RssIcon,
  ScribdIcon,
  TiktokIcon,
  TwitterIcon,
  YoutubeIcon
} from 'assets/inline-icons'
import {GeneralData, LinkType, SocialType} from 'types'
import {Mod, style} from 'util/style'

import logoEco from 'assets/images/eco.png'
import logoFodEN from 'assets/images/fod-en-2023.svg'
import logoFodFR from 'assets/images/fod-fr-2023.svg'
import logoFodNL from 'assets/images/fod-nl-2023.svg'
import {Component} from 'react'
import {useLanguage} from 'util/i18n'
import {PageLink as Link} from 'util/pagelink'
import {Theme} from 'views/theme'

const styles = style('footer', ['top', 'main', 'social', 'socialitem'])

export type FooterSocialItemType = LinkType
export type FooterSocialItemContainerType = SocialType

export class Footer extends Component<{data: GeneralData}> {
  render() {
    const lang = useLanguage()
    const fodLogo = this.getLogo(lang)
    const {footer, social} = this.props.data
    if (!footer) return null
    return (
      <footer class={styles}>
        <div class={styles.top}>
          <FooterTop {...this.props.data} />
        </div>
        <Theme.Container class={styles('container')}>
          <div class={styles.main}>
            <div class={styles('logo')}>
              <Link to={footer && footer.logolink && footer.logolink.url}>
                <Image
                  {...fodLogo}
                  alt={
                    lang === 'en'
                      ? 'FPS Public Health'
                      : lang === 'fr'
                        ? 'SPF Santé Publique'
                        : 'FOD Volksgezondheid'
                  }
                />
              </Link>
            </div>
            <div class={styles.main('content')}>
              <Theme.Wysiwyg class={styles('copyright')}>
                {footer.copyright}
              </Theme.Wysiwyg>
              <Theme.Wysiwyg class={styles('text')}>
                {footer.text}
              </Theme.Wysiwyg>
            </div>
          </div>
          <div class={styles('green')}>
            <div class={styles('green-image')}>
              <Image {...logoEco} alt={this.getLogoEcoAlt(lang)} />
            </div>
            <Theme.Wysiwyg class={styles('green-text')}>
              {footer.green}
            </Theme.Wysiwyg>
          </div>
        </Theme.Container>
      </footer>
    )
  }

  getLogoEcoAlt = (lang: string) => {
    switch (lang) {
      case 'fr':
        return "Icône d'une feuille verte"
      default:
        return 'Icoon van een groen blaadje'
    }
  }

  getLogo = (lang: string) => {
    switch (lang) {
      case 'en':
        return logoFodEN
      case 'fr':
        return logoFodFR
    }
    return logoFodNL
  }
}
export const FooterTop: React.FC<
  GeneralData & {mod?: Mod<'navigation'>; closenav?: () => void}
> = ({social, mod, footer, closenav}) => {
  return (
    <Theme.Container class={styles.top('container')}>
      <div class={styles.top('social')}>
        {social && <FooterSocialContainer {...social} />}
      </div>
      {footer && footer.nav ? (
        <div class={styles.top('menu')}>
          {footer.nav.map(nav => (
            <div class={styles.top('menu-item').mod(mod)}>
              <Theme.Link
                onClick={() => {
                  if (mod === 'navigation') closenav()
                }}
                to={nav.url}
              >
                {nav.description ? nav.description : nav.title}
              </Theme.Link>
            </div>
          ))}
        </div>
      ) : null}
    </Theme.Container>
  )
}
const FooterSocialContainer: React.FC<FooterSocialItemContainerType> = ({
  ...social
}) => (
  <ul class={styles.social}>
    {Object.entries(social).map(
      ([keyname, item]) =>
        item && <FooterSocialItem keyname={keyname} {...(item as any)} />
    )}
  </ul>
)

const FooterSocialItem: React.FC<FooterSocialItemType & {keyname: any}> = ({
  keyname,
  ...socialitem
}) => (
  <li class={styles.socialitem}>
    <a
      href={socialitem.url}
      class={styles.socialitem('link').mod(keyname)}
      target="_blank"
      title={(() => {
        switch (keyname) {
          case 'linkedin':
            return 'Go to LinkedIn'
          case 'rss':
            return 'Go to RSS-feed'
          case 'Scribd':
            return 'Go to Scribd'
          case 'twitter':
            return 'Go to X (Twitter)'
          default:
            return keyname
        }
      })()}
    >
      {getSocialIconByKeyname(keyname)}
    </a>
  </li>
)

const getSocialIconByKeyname: React.FC = (keyname: any) => {
  switch (keyname) {
    case 'facebook':
      return <FacebookIcon class={styles.socialitem('icon')} />
    case 'instagram':
      return <InstagramIcon class={styles.socialitem('icon')} />
    case 'linkedin':
      return <LinkedinIcon class={styles.socialitem('icon')} />
    case 'rss':
      return <RssIcon class={styles.socialitem('icon')} />
    case 'tiktok':
      return <TiktokIcon class={styles.socialitem('icon')} />
    case 'twitter':
      return <TwitterIcon class={styles.socialitem('icon')} />
    case 'youtube':
      return <YoutubeIcon class={styles.socialitem('icon')} />
    case 'scribd':
      return <ScribdIcon class={styles.socialitem('icon')} />
  }
}
